module.exports = __webpack_public_path__ + "img/Madera-Caucho1.7b54fdd5.jpg";